import React from 'react';

import { ia } from 'lib/helpers/utility';

import Button from 'components/shared/Buttons/Button';
import Icon from 'components/shared/Icon/Icon';
import Modal from 'components/shared/Modal/Modal';

const ErrorModal = ({ superbill, isOpen, handleClose, errors }) => {
  if (!ia(errors)) return null;

  const goToSuperbillHandler = () => {
    window.open(
      `/portal/charts/${superbill?.patient_id}/billing/superbill/${superbill.id}`,
      '_blank'
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      title={
        <div className="flex items-center gap-2">
          <Icon icon="info-mono" color="danger" size={24} />
          {`Superbill #${superbill.id} Errors`}
        </div>
      }
      footer={
        <div className="flex w-full justify-between">
          <Button
            outlined
            text="Cancel"
            color="neutral"
            onClick={handleClose}
            id="closeServiceModalBtn"
          />
          <Button
            onClick={goToSuperbillHandler}
            text="Go to superbill"
            id="createUpdateServiceBtn"
            data-qa="create-update-service-btn"
          />
        </div>
      }>
      <ul className="flex list-disc flex-col gap-2 pl-4">
        {errors.map((error) => (
          <li key={error} className="text-sm text-red-500">
            {error}
          </li>
        ))}
      </ul>
    </Modal>
  );
};

export default ErrorModal;
